// extracted by mini-css-extract-plugin
export default {"introSection":"MacPage_introSection__4XW-j"};